<template>
    <div class="varietyofdisheslist ">
        <div class="top">
            <el-col :span="19">
               <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button>
               <el-select class="filter-item" v-model="listQuery.typeId" size="medium" @change="handleFilter()">
                   <el-option v-for="item in foodTypeList" :key="item.id" :label="item.value" :value="item.id"></el-option>
               </el-select>
            </el-col>
            <el-col :span="5">
                <el-input size="medium"  placeholder="请输入菜品名称" v-model.trim="listQuery.searchName" @change="handleFilter">
                  <el-button size="medium" slot="append" icon="el-icon-search" @click="handleFilter"></el-button>
                </el-input>
            </el-col>
        </div>			
        <el-table stripe :data="dataList"  :height="`${windowHeight-220}px`" border style="width: 100%" > 
           <el-table-column  label="图片"  align="center" width="60">
                <template slot-scope="scope">
                    <img class="img" :src="scope.row.pic" alt="">
                </template>
            </el-table-column>      
            <el-table-column  label="名称" show-overflow-tooltip  width="180">
                <template slot-scope="scope">
                    <span class="link-type" @click="varietyofdisheslistInfo(scope.row.id)">{{scope.row.name}}</span>
                </template>
            </el-table-column>  
            <el-table-column label="分类" align="center" width="120">
                <template slot-scope="scope">
                        {{scope.row.typeName}}
                </template>
            </el-table-column> 
            <el-table-column label="成分及配比" show-overflow-tooltip>
                <template slot-scope="scope">
                      <span v-for="(item,index) in scope.row.materialList" :key="index">{{item.materialName}}{{item.percent}}%;</span>
                </template>
            </el-table-column> 
             <el-table-column label="操作" align="center" width="120">
                 <template slot-scope="scope">                        
                         <el-button  @click.native.prevent="varietyofdisheslisteidt(scope.row.id)"  type="text" size="small">编辑</el-button>
                          <el-button  @click.native.prevent="publishFoods(scope.row.id)"  type="text" size="small">审核通过</el-button>
                    </template>
            </el-table-column> 
        </el-table>
        <el-pagination
            class="pagination-container"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="listQuery.pageNo"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="listQuery.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
    </div>
</template>
<script>
    import {findDicsByCode,queryUnPublishedFood,publishFood} from '@/api/foodSetting';
    import mixin from '@/mixins/windowResize';
    export default {
        data() {
            return {
                listQuery: {
                    pageNo: 1,
                    pageSize: 20,
                    searchName: '',
                    typeId:'0'
                },
                dataList: [],
                total: null,
                foodTypeList:[],
                selected:[],
                menuIds:''
            }
        },
        created() {
            this.queryUnPublishedFoods();
            findDicsByCode('foodType').then(res=>{
                this.foodTypeList=[{id:'0',value:'全部'}];
                for(let i=0;i<res.data.data.length;i++){
                  this.foodTypeList.push(res.data.data[i])
                }
            }).catch();
        },
        mixins: [mixin],       
        methods: { 
             publishFoods(id){
              this.$confirm('此操作将审核通过此菜品, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    publishFood(id).then(res => {
                        this.$message({
                            type: 'success',
                            message: '审核通过成功!'
                        });
                        this.queryUnPublishedFoods();
                    }).catch();

                }).catch(() => {
                });
             },       
            //获取列表          
            queryUnPublishedFoods() {
                queryUnPublishedFood(this.listQuery)
                    .then(res => res.data)
                    .then(data => {
                        this.dataList = data.data.dataList;
                        this.total = data.data.pagination.total;
                    }).catch(err => {
                })
            },
            //搜索
            handleFilter (){
                this.listQuery.pageNo=1;
                this.queryUnPublishedFoods();
            }, 
            //切换码数          
            handleSizeChange(val) {
                this.listQuery.pageNo=1;
                this.listQuery.pageSize = val;
                this.queryUnPublishedFoods();
            },
            //切换页数
            handleCurrentChange(val) {
                this.listQuery.pageNo = val;
                this.queryUnPublishedFoods();
            },
            //详情
            varietyofdisheslistInfo(id){
              this.$router.push({
                    path: "varietyofdisheslistInfo",
                    query: {id: id}
                });
            },
            //编辑
            varietyofdisheslisteidt(id){
              this.$router.push({
                    path: "varietyofdisheslisteidt",
                    query: {id: id}
                });
            },
        }
    }
</script>
<style lang="scss" scoped>
.varietyofdisheslist{
   padding:12px;
    .pagination-container {
        margin-top: 10px;
    }
    .top{
        padding-bottom: 10px;
        overflow: hidden;
    }
    .img{
      width: 30px;
      height: 30px;
    }
    .link-type{
            cursor: pointer;
            color: #409eff;
    }
}
</style>




// WEBPACK FOOTER //
// src/views/foodSetting/varietyofdisheslist.vue